import { CitizenCharterLeftMenuList } from "../utils/constants";
import { TableStructure } from "../components/TableStructure";

const List = [
  {
    fileStoreId: "18020426-2a59-4f3c-8a94-891f18042026",
    label: "Bengali",
  },
  {
    fileStoreId: "18020526-2a59-4f3c-8a94-891f18042026",
    label: "Hindi",
  },
  {
    fileStoreId: "18020626-2a59-4f3c-8a94-891f18042026",
    label: "English",
  },
];

const Citizen_Charter_Ads = () => (
  <TableStructure
    title="Citizen's Charter ADs"
    heading={"List of Citizen's Charter ADs"}
    list={List}
    columnNo={1}
    leftMenuList={CitizenCharterLeftMenuList}
    longMenuList={false}
  />
);

export default Citizen_Charter_Ads;
